<div class="about-container">
  <mat-card class="about-card">
    <mat-card-header>
      <mat-card-title>About Vision</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-list aria-label="Application information">
        <mat-list-item>
          <mat-icon mat-list-icon aria-hidden="true">tag</mat-icon>
          <span matLine>Version</span>
          <span matLine>v{{ version }}</span>
        </mat-list-item>

        <mat-divider></mat-divider>

        <mat-list-item>
          <mat-icon mat-list-icon aria-hidden="true">dns</mat-icon>
          <span matLine>Environment</span>
          <span matLine>{{ environmentName }}</span>
        </mat-list-item>

        <mat-divider></mat-divider>

        <mat-list-item>
          <mat-icon mat-list-icon aria-hidden="true">copyright</mat-icon>
          <span matLine>Copyright</span>
          <span matLine>&copy; {{ currentYear }} ACT Training</span>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
</div>
